<template>
    <Card :bordered="false" class="border-radius-0">
        <Form :ref="(e) => (refs.form = e)" layout="horizontal">
            <TemplateBuilder
                :rowProp="data.rowProp"
                :useForm="data.useForm"
                :fields="data.fields"
                :skeleton="isLoadingApp"
            ></TemplateBuilder>
        </Form>
        <Tabs>
            <TabPane key="UserInstead" :tab="$t('model.userInstead.modelName')">
                <UserInsteadList
                        v-if="data && data.useForm && data.userInsteads?.fetchCriteria && !isLoadingApp"
                        :menuContext="menuContext"
                        :viewOnly="viewOnly"
                        :useForm="data.useForm"
                        :parent="data.useForm?.modelRef"
                        :fetchCriteria="data.userInsteads?.fetchCriteria"
                        :visibleSearch="false"
                        :isChildren="true"
                ></UserInsteadList>
            </TabPane>
        </Tabs>
    </Card>
</template>

<script>
import { Card, Form, Tabs } from "ant-design-vue";
import { computed, defineAsyncComponent, defineComponent, reactive } from "vue";
import { state as stateApp, isLoading as isLoadingApp } from "../../../app.logic";
import { createFormTitle, initForm } from "./profile.logic";

export default defineComponent({
    components: {
        Card,
        Form,
        Tabs,
        TabPane: Tabs.TabPane,
        TemplateBuilder: defineAsyncComponent(() => import("../../../components/input/template-builder/TemplateBuilder")),
        UserInsteadList: defineAsyncComponent(() => import("./UserInsteadList")),
    },
    props: {
        menuContext: { default: () => stateApp.menuContext },
    },
    setup(props) {
        const data = reactive({ rowProp: { gutter: 24 } });
        const refs = reactive({ form: null, changePassword: null });
        initForm({ props, data, refs });
        const title = computed(() => createFormTitle({ data }));
        return {
            props,
            data,
            refs,
            title,
            isLoadingApp,
        };
    },
});
</script>
